import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Upload } from 'lucide-react';
import { FilePlus } from 'lucide-react';
import { Folder } from 'lucide-react';
import { Download } from 'lucide-react';
import { Trash2 } from 'lucide-react';
import { Copy } from 'lucide-react';
import toast from 'react-hot-toast';
const Container = styled.div`
  padding: 1.5rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;
const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
`;
const Actions = styled.div`
  display: flex;
  gap: 0.75rem;
`;
const ResourceButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid transparent;

  &.primary {
    background-color: #2563eb;
    color: white;
    border-color: #2563eb;
    &:hover { background-color: #1d4ed8; }
  }

  &.outline {
    background-color: white;
    color: #374151;
    border-color: #d1d5db;
    &:hover { background-color: #f9fafb; }
  }
`;
const ResourceList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const ResourceItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`;
const ResourceInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
const ResourceName = styled.span`
  font-weight: 500;
  color: #374151;
`;
const ResourceActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const ActionButton = styled.button`
  background: none;
  border: none;
  padding: 0.25rem;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #f3f4f6;
    color: #1f2937;
  }
`;
const ResourcesTabContent = ({ courseId })=>{
    // TODO: 실제 자료 목록 상태 관리 및 API 연동 필요
    const resources = [
        {
            id: '1',
            name: '강의소개.pdf',
            type: 'file',
            url: '/uploads/course/123/강의소개.pdf'
        },
        {
            id: '2',
            name: '실습 코드.zip',
            type: 'file',
            url: '/uploads/course/123/실습_코드.zip'
        },
        {
            id: '3',
            name: '참고 자료',
            type: 'folder',
            url: '/folders/course/123/참고_자료'
        }
    ];
    const handleUploadFile = ()=>{
        console.log('파일 업로드');
    // 파일 업로드 로직 구현
    };
    const handleCreateFolder = ()=>{
        console.log('폴더 생성');
    // 폴더 생성 로직 구현
    };
    const handleDownload = (resourceId)=>{
        console.log(`자료 다운로드: ${resourceId}`);
    // 다운로드 로직 구현
    };
    const handleDelete = (resourceId)=>{
        console.log(`자료 삭제: ${resourceId}`);
    // 삭제 로직 구현
    };
    const handleCopyUrl = (url)=>{
        navigator.clipboard.writeText(url).then(()=>{
            console.log('URL copied to clipboard:', url);
            toast.success('URL이 클립보드에 복사되었습니다.');
        }).catch((err)=>{
            console.error('Failed to copy URL:', err);
            toast.error('URL 복사에 실패했습니다.');
        });
    };
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsx(Title, {
                        children: "강의 자료 관리"
                    }),
                    /*#__PURE__*/ _jsxs(Actions, {
                        children: [
                            /*#__PURE__*/ _jsxs(ResourceButton, {
                                className: "outline",
                                onClick: handleCreateFolder,
                                children: [
                                    /*#__PURE__*/ _jsx(Folder, {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "폴더 생성"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ResourceButton, {
                                className: "primary",
                                onClick: handleUploadFile,
                                children: [
                                    /*#__PURE__*/ _jsx(Upload, {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "파일 업로드"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ResourceList, {
                children: resources.map((resource)=>/*#__PURE__*/ _jsxs(ResourceItem, {
                        children: [
                            /*#__PURE__*/ _jsxs(ResourceInfo, {
                                children: [
                                    resource.type === 'folder' ? /*#__PURE__*/ _jsx(Folder, {
                                        size: 18,
                                        color: "#9ca3af"
                                    }) : /*#__PURE__*/ _jsx(FilePlus, {
                                        size: 18,
                                        color: "#6b7280"
                                    }),
                                    /*#__PURE__*/ _jsx(ResourceName, {
                                        children: resource.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ResourceActions, {
                                children: [
                                    /*#__PURE__*/ _jsx(ActionButton, {
                                        onClick: ()=>handleCopyUrl(resource.url),
                                        title: "URL 복사",
                                        children: /*#__PURE__*/ _jsx(Copy, {
                                            size: 16
                                        })
                                    }),
                                    resource.type === 'file' && /*#__PURE__*/ _jsx(ActionButton, {
                                        onClick: ()=>handleDownload(resource.id),
                                        title: "다운로드",
                                        children: /*#__PURE__*/ _jsx(Download, {
                                            size: 16
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ActionButton, {
                                        onClick: ()=>handleDelete(resource.id),
                                        title: "삭제",
                                        children: /*#__PURE__*/ _jsx(Trash2, {
                                            size: 16
                                        })
                                    })
                                ]
                            })
                        ]
                    }, resource.id))
            })
        ]
    });
};
